import React, { useState } from "react";
import "./SignIn.css";
import { IoMdCloseCircleOutline } from "react-icons/io";

const SignIn = ({ handleModalOpen }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (!handleModalOpen) {
    console.error("handleModalOpen function is not passed to SignIn component");
    return null;
  }

  const handleSignIn = (e) => {
    e.preventDefault();

    // Simple check to ensure fields are not empty
    if (email.trim() === "" || password.trim() === "") {
      alert("Please fill in all fields.");
      return;
    }

    // Redirect to enterprise.chauwk.com after successful login
    window.location.href = "https://enterprise.chauwk.com/dashboard";
  };

  return (
    <div className="signin-container">
      <div className="signin-box">
        <div className="close-icon" onClick={() => handleModalOpen(null)}>
          <IoMdCloseCircleOutline size={30} />
        </div>

        <div className="back-icon" onClick={() => handleModalOpen("register")}>
          <span>&#8592;</span>
          <span>Back</span>
        </div>

        <h2>Sign In</h2>
        <form onSubmit={handleSignIn}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Sign In</button>
        </form>

        <p>
          Don't have an account?{" "}
          <button onClick={() => handleModalOpen("register")}>Register</button>
        </p>
      </div>
    </div>
  );
};

export default SignIn;
